/**
 * reactivityPulse — thin emit helper for the world-combat reactivity bus
 * (docs/plans/fx-grammar-specs/world-combat-reactivity.md §3.1).
 *
 * Emits EVENTS.ATMOSPHERE_PULSE; the AtmosphereReactivityDriver resolves the
 * response table (pulse × school × biome family) and pushes gated envelopes
 * into the AtmosphereLayer. Emitting through the bus (not a direct
 * AtmosphereLayer call) keeps the decouple doctrine: combat code never imports
 * atmosphere internals, and ChoreographyDriver cues can fire pulses via their
 * existing `emit` beat with zero new plumbing.
 */
import { EventBus, EVENTS } from '../../../shared/EventBus';
import type { ReactivityPulseKind } from '../../../config/atmosphere/reactivity.config';

export function reactivityPulse(
  kind: ReactivityPulseKind,
  position: { x: number; y: number } | null, // null = position-less (playerDamaged)
  intensity: number, // 0..1, clamped by the model
  school?: string, // qualifies the response lookup (aliased like reactionMatrix)
): void {
  EventBus.getInstance().emit(EVENTS.ATMOSPHERE_PULSE, {
    kind,
    x: position?.x ?? 0,
    y: position?.y ?? 0,
    hasPosition: !!position,
    intensity,
    ...(school ? { school } : {}),
  });
}
